import React from 'react';
import { Zap, FileText, MessageCircle, ThumbsUp, Users, AlertTriangle } from 'lucide-react';

const BetaBenefits = () => {
  const benefits = [
    {
      icon: <Zap className="h-6 w-6 text-blue-600" />,
      title: "1 Resumo Flash por caso",
      description: "Análise rápida com principais riscos e valor em faixa"
    },
    {
      icon: <FileText className="h-6 w-6 text-blue-600" />,
      title: "1 Laudo (PDF) com checklist de riscos + viabilidade",
      description: "Documento completo para tomada de decisão"
    },
    {
      icon: <MessageCircle className="h-6 w-6 text-blue-600" />,
      title: "Acesso ao agente via WhatsApp",
      description: "Tire dúvidas e solicite análises diretamente"
    },
    {
      icon: <ThumbsUp className="h-6 w-6 text-blue-600" />,
      title: "Solicitação de feedback de 1 minuto",
      description: "Ajude-nos a melhorar o produto para CBs"
    }
  ];

  return (
    <section className="py-20 bg-slate-50">
      <div className="container mx-auto px-4 md:px-8">
        <div className="text-center max-w-3xl mx-auto mb-16">
          <h2 className="text-3xl md:text-4xl font-bold mb-6 text-slate-900">
            O que você recebe no Beta (grátis)
          </h2>
        </div>

        <div className="max-w-4xl mx-auto">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-12">
            {benefits.map((benefit, index) => (
              <div key={index} className="bg-white p-6 rounded-xl shadow-md border border-slate-100">
                <div className="flex items-start gap-4">
                  <div className="bg-blue-100 p-3 rounded-lg">
                    {benefit.icon}
                  </div>
                  <div>
                    <h3 className="font-semibold text-lg text-slate-900 mb-2">
                      {benefit.title}
                    </h3>
                    <p className="text-slate-600">
                      {benefit.description}
                    </p>
                  </div>
                </div>
              </div>
            ))}
          </div>

          <div className="bg-gradient-to-r from-green-50 to-emerald-50 p-8 rounded-2xl border border-green-200 text-center">
            <div className="flex items-center justify-center gap-2 mb-4">
              <Users className="h-6 w-6 text-green-600" />
              <h3 className="text-xl font-semibold text-green-800">
                Vagas limitadas durante o Beta
              </h3>
            </div>
            <p className="text-green-700">
              Sem custo para CBs participantes. Participe agora e ajude a moldar o futuro da análise de leilões.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default BetaBenefits;